var _defs, _path, _use, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeakMermaidRedhead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 122,
    height: 166,
    viewBox: "189 100 122 166",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "rh-clip-0"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 52 46 L 113.257812 46 L 113.257812 67 L 52 67 Z M 52 46 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "rh-clip-1"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 18 0.304688 L 30 0.304688 L 30 16 L 18 16 Z M 18 0.304688 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "rh-clip-2"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 14 59 L 85 59 L 85 124.738281 L 14 124.738281 Z M 14 59 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "rh-clip-3"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "nonzero",
    d: "M 0.738281 0.304688 L 38 0.304688 L 38 66 L 0.738281 66 Z M 0.738281 0.304688 "
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "rh-clip-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 114,
    height: 125
  })), /*#__PURE__*/React.createElement("g", {
    id: "rh-source-5",
    clipPath: "url(#rh-clip-4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rh-clip-0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(7.843018%, 39.99939%, 33.724976%)",
    fillOpacity: 1,
    d: "M 89.410156 66.84375 C 73.300781 61.035156 52.980469 63.246094 52.980469 63.246094 C 61.621094 56.078125 74.71875 48.339844 92.132812 46.722656 C 92.132812 46.722656 106.34375 46.269531 113.257812 51.433594 C 113.257812 51.433594 105.761719 66.378906 89.574219 66.378906 Z M 89.410156 66.84375 "
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(97.647095%, 96.078491%, 92.941284%)",
    fillOpacity: 1,
    d: "M 39.34375 5.6875 C 44.195312 12.558594 39.507812 23.894531 37.765625 25.859375 C 36.015625 27.824219 32.839844 26.136719 32.839844 26.136719 C 31.644531 29.738281 32.390625 32.09375 32.390625 32.09375 C 32.390625 32.09375 39.402344 32.183594 46.484375 36.101562 C 53.570312 40.027344 54.101562 38.320312 54.101562 38.320312 L 54.304688 26.457031 C 53.667969 25.132812 53.265625 23.308594 53.265625 21.296875 C 53.265625 17.261719 56.824219 14 56.824219 14 C 56.824219 14 60.394531 17.261719 60.394531 21.296875 C 60.394531 23.003906 60.105469 24.582031 59.625 25.828125 L 59.460938 47.023438 L 37.453125 44.070312 L 37.4375 44.183594 L 39.835938 53.003906 C 39.835938 53.003906 39.285156 56.792969 35.53125 55.84375 C 32.203125 60.929688 32.90625 68.234375 32.90625 68.234375 L 20.144531 59.828125 C 21.8125 51.734375 19.875 42.882812 19.875 42.882812 L 19.605469 42.671875 C 20.871094 41.058594 22.304688 39.601562 23.695312 38.390625 C 33.070312 30.277344 29.558594 17.546875 29.558594 17.546875 L 29.339844 17.359375 C 34.425781 11.550781 37.390625 6.519531 37.8125 3.78125 C 38.117188 4.089844 38.402344 4.425781 38.671875 4.769531 Z M 39.34375 5.6875 "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(7.843018%, 39.99939%, 33.724976%)",
    fillOpacity: 1,
    d: "M 60.171875 64.441406 C 59.066406 64.792969 49.808594 68.007812 52.15625 79.238281 L 51.992188 80.292969 C 46.371094 79.441406 42.402344 77.980469 39.605469 76.351562 L 40.605469 76.328125 C 40.605469 76.328125 43.980469 71.246094 50.632812 65.273438 C 54.136719 64.179688 57.300781 63.980469 60.171875 64.441406 "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(7.843018%, 39.99939%, 33.724976%)",
    fillOpacity: 1,
    d: "M 81.664062 82.214844 C 76.753906 75.550781 70.257812 66.011719 60.179688 64.441406 C 60.179688 64.449219 60.171875 64.441406 60.171875 64.441406 C 57.300781 63.980469 54.132812 64.179688 50.632812 65.273438 C 51.378906 64.601562 52.15625 63.925781 52.980469 63.246094 C 52.980469 63.246094 73.300781 61.035156 89.410156 66.84375 C 95.78125 69.144531 101.484375 72.703125 105.019531 78.140625 C 113.257812 90.832031 110.6875 100.015625 110.6875 100.015625 C 110.6875 100.015625 89.464844 92.828125 81.664062 82.214844 "
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(100%, 47.843137%, 10.196078%)",
    fillOpacity: 1,
    d: "M 19.605469 42.671875 C 15.113281 48.347656 12.488281 55.972656 19.703125 61.578125 L 19.71875 61.578125 C 19.605469 61.992188 19.472656 62.417969 19.324219 62.828125 L 19.316406 62.828125 C 19.316406 62.828125 -1.273438 42.753906 13.445312 31.855469 C 19.949219 27.039062 25.3125 21.949219 29.339844 17.359375 L 29.558594 17.546875 C 29.558594 17.546875 33.070312 30.277344 23.695312 38.394531 C 22.304688 39.601562 20.871094 41.058594 19.605469 42.671875 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rh-clip-1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(100%, 47.843137%, 10.196078%)",
    fillOpacity: 1,
    d: "M 18.546875 15.296875 C 18.214844 14.210938 18.023438 13.046875 18.023438 11.839844 C 18.023438 5.472656 23.1875 0.304688 29.558594 0.304688 C 29.558594 0.304688 24.898438 10.660156 18.761719 15.550781 Z M 18.546875 15.296875 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rh-clip-2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(7.843018%, 39.99939%, 33.724976%)",
    fillOpacity: 1,
    d: "M 40.511719 102.773438 C 36.71875 102.421875 32.480469 101.613281 27.777344 100.015625 C 10.65625 94.234375 13.753906 74.160156 18.292969 65.273438 C 18.695312 64.488281 19.039062 63.671875 19.324219 62.828125 C 19.472656 62.417969 19.605469 61.992188 19.71875 61.578125 C 19.882812 60.996094 20.019531 60.414062 20.144531 59.828125 L 32.90625 68.234375 C 32.90625 68.234375 33.289062 72.695312 39.605469 76.351562 C 42.402344 77.976562 46.371094 79.445312 51.992188 80.292969 C 53.96875 80.597656 56.15625 80.816406 58.570312 80.949219 L 62.480469 80.808594 C 74.609375 80.808594 84.453125 90.640625 84.453125 102.773438 C 84.453125 114.90625 74.609375 124.738281 62.480469 124.738281 C 50.347656 124.738281 40.523438 114.914062 40.511719 102.78125 Z M 40.511719 102.773438 "
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rh-clip-3)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(100%, 47.843137%, 10.196078%)",
    fillOpacity: 1,
    d: "M 18.292969 65.273438 C -17.011719 37.523438 10.71875 20.84375 17.484375 16.476562 C 17.917969 16.199219 18.34375 15.886719 18.761719 15.550781 C 24.898438 10.660156 29.558594 0.304688 29.558594 0.304688 C 32.789062 0.304688 35.71875 1.636719 37.8125 3.78125 C 37.390625 6.519531 34.425781 11.550781 29.339844 17.359375 C 25.3125 21.949219 19.945312 27.039062 13.445312 31.855469 C -1.273438 42.753906 19.316406 62.828125 19.316406 62.828125 L 19.324219 62.828125 C 19.039062 63.671875 18.695312 64.488281 18.292969 65.273438 "
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "rgb(0%, 0%, 0%)",
    fillOpacity: 1,
    d: "M 261.710938 122.804688 L 260.746094 103.964844 L 257.539062 103.992188 L 257.53125 122.742188 C 257.53125 124.027344 256.742188 125.183594 255.730469 125.855469 C 254.640625 126.578125 253.859375 126.988281 252.453125 127.265625 L 252.027344 104.09375 L 247.964844 104.09375 L 247.539062 127.265625 C 246.136719 126.988281 245.355469 126.578125 244.265625 125.855469 C 243.253906 125.183594 242.464844 124.027344 242.460938 122.742188 L 242.453125 103.992188 L 239.246094 103.964844 L 238.285156 122.804688 C 238.175781 125.320312 239.796875 127.507812 241.730469 128.851562 C 243.523438 130.097656 245.214844 131.238281 246.878906 132.566406 L 247.882812 134.882812 L 247.882812 165.269531 C 247.882812 166.433594 248.835938 167.382812 249.996094 167.382812 C 251.160156 167.382812 252.109375 166.433594 252.109375 165.269531 L 252.109375 134.660156 L 253.035156 132.625 C 254.730469 131.273438 256.441406 130.121094 258.261719 128.851562 C 260.199219 127.507812 261.816406 125.320312 261.710938 122.804688 "
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rh-source-5",
    transform: "matrix(1, 0, 0, 1, 193, 136)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    stroke: "rgb(0%, 0%, 0%)",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00186875 -0.001725 C 0.00186875 -0.001725 3.380775 5.080306 10.029213 11.052962 C 10.775306 11.724837 11.55265 12.400619 12.376869 13.080306 C 21.017494 20.248275 34.111244 27.986556 51.529213 29.60765 C 51.529213 29.60765 65.74015 30.056869 72.650306 24.892806 C 72.650306 24.892806 65.158119 9.947494 48.970619 9.947494 ",
    transform: "matrix(1, 0, 0, -1, 233.6036, 212.3264)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    stroke: "rgb(0%, 0%, 0%)",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.000075 -0.00160625 C -2.871019 0.459331 -6.035081 0.260112 -9.538987 -0.833638 ",
    transform: "matrix(1, 0, 0, -1, 253.1718, 200.4398)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    stroke: "rgb(0%, 0%, 0%)",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00053125 -0.00059375 C -0.00053125 -0.00059375 20.319781 2.210344 36.429156 -3.59825 C 42.80025 -5.899031 48.503375 -9.457625 52.038531 -14.895125 C 60.276812 -27.586531 57.7065 -36.770125 57.7065 -36.770125 C 57.7065 -36.770125 36.48775 -29.582625 28.679156 -18.969344 C 23.772906 -12.305281 17.276812 -2.766219 7.198687 -1.195906 ",
    transform: "matrix(1, 0, 0, -1, 245.981, 199.2455)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    stroke: "rgb(0%, 0%, 0%)",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00075625 0.0012375 C -0.00075625 0.0012375 -0.0320062 -0.006575 -0.0984125 -0.0261062 C -0.0984125 -0.0339187 -0.106225 -0.0261062 -0.106225 -0.0261062 C -1.211694 -0.377669 -10.469506 -3.592512 -8.12185 -14.822981 C -8.082787 -14.994856 -8.043725 -15.182356 -8.000756 -15.362044 ",
    transform: "matrix(1, 0, 0, -1, 253.2781, 200.4153)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    stroke: "rgb(0%, 0%, 0%)",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00188125 0.00145 C 11.158275 -1.053237 18.470775 1.767075 22.595775 0.00145 C 28.123119 -2.37355 25.947338 -6.7173 25.947338 -6.7173 ",
    transform: "matrix(1, 0, 0, -1, 233.5136, 238.7827)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    stroke: "rgb(0%, 0%, 0%)",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.0012 0.0009875 C 0.0012 0.0009875 1.9387 -8.850575 0.270731 -16.940419 C 0.145731 -17.530262 0.0090125 -18.112294 -0.15505 -18.694325 C -0.268331 -19.108387 -0.401144 -19.534169 -0.549581 -19.944325 C -0.834737 -20.788075 -1.178487 -21.604481 -1.580831 -22.389637 C -6.119894 -31.276356 -9.221456 -51.350575 7.903544 -57.135731 C 12.606669 -58.729481 16.84495 -59.538075 20.641825 -59.889637 ",
    transform: "matrix(1, 0, 0, -1, 212.8738, 178.8838)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    stroke: "rgb(0%, 0%, 0%)",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.001725 0.00061875 L 0.0334313 -0.026725 L 12.79515 -8.432975 C 12.79515 -8.432975 13.177963 -12.893912 19.494369 -16.550162 C 22.291244 -18.175162 26.259994 -19.643912 31.881088 -20.491569 C 33.861556 -20.796256 36.04515 -21.015006 38.455306 -21.147819 L 42.369369 -21.007194 C 54.498275 -21.007194 64.342025 -30.839225 64.342025 -42.972037 C 64.342025 -55.10485 54.498275 -64.936881 42.369369 -64.936881 C 30.236556 -64.936881 20.412338 -55.112662 20.404525 -42.97985 L 20.404525 -42.972037 ",
    transform: "matrix(1, 0, 0, -1, 213.1111, 195.8014)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    stroke: "rgb(0%, 0%, 0%)",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00065 0.001325 C 0.00065 0.001325 -0.702475 7.306013 2.62565 12.395856 ",
    transform: "matrix(1, 0, 0, -1, 225.9056, 204.2357)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    stroke: "rgb(0%, 0%, 0%)",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.0002 0.00090625 L 2.398237 -8.819406 C 2.398237 -8.819406 1.847456 -12.604562 -1.90645 -11.655344 C -2.601763 -11.475656 -3.418169 -11.135812 -4.367388 -10.569406 ",
    transform: "matrix(1, 0, 0, -1, 230.4377, 180.1845)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    stroke: "rgb(0%, 0%, 0%)",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 0.00179375 -0.00060625 L 3.271325 -0.442012 L 25.279137 -3.395137 L 25.4432 17.800175 C 25.923669 19.046269 26.212731 20.624394 26.212731 22.331425 C 26.212731 26.366581 22.642419 29.6283 22.642419 29.6283 C 22.642419 29.6283 19.083825 26.366581 19.083825 22.331425 C 19.083825 20.319706 19.486169 18.495488 20.122887 17.171269 L 19.919762 5.307988 C 19.919762 5.307988 19.388512 3.600956 12.302575 7.526738 C 5.220544 11.444706 -1.791175 11.53455 -1.791175 11.53455 C -1.791175 11.53455 -2.537269 13.890019 -1.341956 17.491581 C -1.341956 17.491581 1.833825 15.804081 3.583825 17.768925 C 5.326012 19.733769 10.013512 31.069706 5.16195 37.9408 L 4.490075 38.858769 C 4.220544 39.202519 3.935387 39.538456 3.6307 39.84705 C 1.53695 41.991581 -1.392738 43.323613 -4.623206 43.323613 C -10.9943 43.323613 -16.158363 38.155644 -16.158363 31.788456 C -16.158363 30.577519 -15.970863 29.417363 -15.634925 28.331425 ",
    transform: "matrix(1, 0, 0, -1, 227.1818, 179.6283)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    stroke: "rgb(0%, 0%, 0%)",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00110625 -0.0011875 C -0.00110625 -0.0011875 -4.661262 -10.356656 -10.797981 -15.247281 C -11.21595 -15.583219 -11.641731 -15.895719 -12.075325 -16.173062 C -18.84095 -20.54025 -46.571419 -37.223844 -11.266731 -64.969937 ",
    transform: "matrix(1, 0, 0, -1, 222.5597, 136.3035)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    stroke: "rgb(0%, 0%, 0%)",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00109375 0.000175 C -0.00109375 0.000175 -20.590937 20.074394 -5.872187 30.972831 C 0.631719 35.789238 5.995 40.879081 10.022344 45.468925 C 15.108281 51.277519 18.069219 56.308769 18.495 59.04705 ",
    transform: "matrix(1, 0, 0, -1, 212.3175, 198.8283)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    stroke: "rgb(0%, 0%, 0%)",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M -0.00110625 0.001425 C -0.00110625 0.001425 3.510613 -12.729044 -5.864387 -20.842325 C -7.255012 -22.053262 -8.688606 -23.510294 -9.954231 -25.123575 C -14.446419 -30.799356 -17.071419 -38.424356 -9.856575 -44.029825 ",
    transform: "matrix(1, 0, 0, -1, 222.5597, 153.5483)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeakMermaidRedhead);
export default __webpack_public_path__ + "static/media/peak-mermaid-redhead.95ebfb281eac7bd296495fd08eeba2a5.svg";
export { ForwardRef as ReactComponent };